var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrowCarousalGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 50,
    viewBox: "0 0 22 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.755986 22.5247L16.6084 1.0262C17.6168 -0.342072 19.2517 -0.342072 20.2596 1.0262C21.2676 2.39326 21.2676 4.61049 20.2596 5.97744L6.23273 25.0004L20.2592 44.0226C21.2672 45.3902 21.2672 47.6072 20.2592 48.9743C19.2512 50.3419 17.6164 50.3419 16.608 48.9743L0.755577 27.4754C0.251581 26.7916 -0.000133296 25.8962 -0.000133217 25.0005C-0.000133138 24.1043 0.25207 23.2083 0.755986 22.5247Z",
    fill: "#ccc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowCarousalGray);
export default __webpack_public_path__ + "static/media/left-arrow-carousal-gray.62ecd0aecd3e86b60c6319d65c4e7046.svg";
export { ForwardRef as ReactComponent };